/**
 * Navigation state which asks the quote editor to open the apply-template modal on arrival.
 * Pass as the `state` option of `navigate`.
 */
export const AUTO_DISPLAY_QUOTE_TEMPLATE_MODAL_STATE = {
  showQuoteTemplateModal: true
}
